export const extractContentData = (contentData) => {
  const abroadSharedProperties = contentData?.abroadSharedPropertiesArea?.expandedValue?.[0] || {};
  const sharedProperties = contentData?.sharedPropertiesArea?.expandedValue?.[0] || {};
  const wizardProperties = contentData?.wizardPropertiesArea?.expandedValue?.[0] || {};

  return {
    callRepresentativeLink: abroadSharedProperties?.callRepresentativeLink?.value || null,
    localCellularTechnicalLobbyLink: abroadSharedProperties?.localCellularTechnicalLobbyLink?.value || null,
    localCellularTechnicalLobbyLinkText: abroadSharedProperties?.localCellularTechnicalLobbyLinkText?.value || null,
    operatorSelectionGuideLink: abroadSharedProperties?.operatorSelectionGuideLink?.value || null,
    operatorSelectionGuideLinkText: abroadSharedProperties?.operatorSelectionGuideLinkText?.value || null,
    privateAbroadLobbyLink: abroadSharedProperties?.privateAbroadLobbyLink?.value || null,
    abroadLobbyLinkText: abroadSharedProperties?.abroadLobbyLinkText?.value || null,
    businessAbroadLobbyLink: abroadSharedProperties?.businessAbroadLobbyLink?.value || null,
    usageCostWithoutPackageLink: abroadSharedProperties?.usageCostWithoutPackageLink?.value || null,
    usageCostWithoutPackageLinkText: abroadSharedProperties?.usageCostWithoutPackageLinkText?.value || null,
    purchasePrivateContinuationPackagesLink: abroadSharedProperties?.purchasePrivateContinuationPackagesLink?.value || null,
    purchaseContinuationLinkText: abroadSharedProperties?.purchaseContinuationPackagesLinkText?.value || null,
    purchaseBusinessContinuationPackagesLink: abroadSharedProperties?.purchaseBusinessContinuationPackagesLink?.value || null,
    deviceBrowsingSettingsGuideLink : abroadSharedProperties?.deviceBrowsingSettingsGuideLink?.value || null,
    deviceBrowsingSettingsGuideLinkText: abroadSharedProperties?.deviceBrowsingSettingsGuideLinkText?.value || null,
    whatsAppNumber: abroadSharedProperties?.whatsAppNumber?.value || null,
    joinServiceLinkText: sharedProperties?.joinServiceLinkText?.value || null,
    paymentMethodUpdateLink: sharedProperties?.paymentMethodUpdateLink?.value || null,
    paymentMethodUpdateLinkText: sharedProperties?.paymentMethodUpdateLinkText?.value || null,
    debtPaymentLinkText: sharedProperties?.debtPaymentLinkText?.value || null,
    loadingGif : sharedProperties?.loadingGif?.value?.url || null,
    kidsControlLink: wizardProperties?.kidsControlLink?.value || null,
    kidsControlLinkText: wizardProperties?.kidsControlLinkText?.value || null,
    smartWizardLink: wizardProperties?.smartWizardLink?.value || null,
    smartWizardLinkText: wizardProperties?.smartWizardLinkText?.value || null,
    finishButtonText: wizardProperties?.finishButtonText?.value || null,
    finishButtonLink: wizardProperties?.finishButtonLink?.value || null,
    abroadCallsRepresentativeLink: wizardProperties?.abroadCallsRepresentativeLink?.value || null,
    abroadCallsRepresentativeLinkText: wizardProperties?.abroadCallsRepresentativeLinkText?.value || null,
  };
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
